import { makeStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { color } from '../../app/theme';
import TextAreaCard from './TextAreaCard';
import Icons from './templates/Icons';
import Template from './templates/Template';

const useStyles = makeStyles(
  () => ({
    template: {
      padding: '16px 12px',
      margin: '8px 0 0 0',
      borderRadius: '12px',
      background: '#FFF',
      boxShadow: '0px 8px 36px rgba(0, 0, 0, 0.06)',
    },
    root: {
      display: 'flex',
      justifyContent: 'right',
      alignItems: 'center',
    },
    title: {
      margin: '12px 0',
      fontFamily: 'PingFang TC',
      fontSize: '15px',
      fontStyle: 'normal',
      fontWeight: 400,
      lineHeight: '15px',
      color: color.$3,
      display: 'flex',
      alignItems: 'center',
    },
    red: {
      color: color.$17,
    },
  }),
  {
    name: 'WhatsAppListOption',
  },
);

function WhatsAppListOption({
  index,
  name,
  desc,
  onNameChange,
  onDescChange,
  onDelete,
  onUp,
  onDown,
  messageLength,
  disabled,
}) {
  const classes = useStyles();
  const { t } = useTranslation();
  const [isModified, setIsModified] = useState(false);

  return (
    <Template className={classes.template}>
      <div className={classes.root}>
        <Icons
          index={index}
          onUp={onUp}
          onDown={onDown}
          onDelete={onDelete}
          messageLength={messageLength}
          disabled={disabled}
        />
      </div>
      <div className={classes.title}>
        {t('waList.optionTitle')}
        <span className={classes.red}>*</span>
      </div>
      <TextAreaCard
        maxCount={20}
        placeholder={t('waList.optionTitlePlaceholder')}
        value={name}
        onChange={v => {
          setIsModified(true);
          onNameChange(v);
        }}
        status={isModified && !name ? 'error' : undefined}
        disabled={disabled}
      />
      <div className={classes.title} style={{ marginTop: '16px' }}>
        {t('waList.optionDesc')}
      </div>
      <TextAreaCard
        maxCount={72}
        placeholder={t('waList.optionDescPlaceholder')}
        value={desc}
        onChange={v => {
          onDescChange(v);
        }}
        disabled={disabled}
      />
    </Template>
  );
}

WhatsAppListOption.defaultProps = {
  onNameChange: () => {},
  onDescChange: () => {},
  onDelete: () => {},
  onUp: () => {},
  onDown: () => {},
  messageLength: 0,
};

WhatsAppListOption.propTypes = {
  onNameChange: PropTypes.func,
  onDescChange: PropTypes.func,
  onDelete: PropTypes.func,
  onUp: PropTypes.func,
  onDown: PropTypes.func,
  messageLength: PropTypes.number,
};

export default WhatsAppListOption;
